export const openWhatsApp = (phone, text='') => {
    let urlWhatApp = 'https://api.whatsapp.com/send?phone=' + phone + '&text='+text;
    window.open(urlWhatApp);
};
